var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevronRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 10,
    viewBox: "0 0 6 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVG",
    clipPath: "url(#clip0_468_145)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "arrow"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Arrow-left-1",
    d: "M0.249989 1.19548C0.247843 1.46003 0.346119 1.71555 0.524989 1.91048L3.44824 5.00011L0.524989 8.08973C0.153608 8.49274 0.153608 9.11328 0.524989 9.51629C0.698183 9.70527 0.942747 9.81287 1.19908 9.81287C1.45542 9.81287 1.69998 9.70527 1.87318 9.51629L5.47018 5.71304C5.84327 5.3115 5.84327 4.69009 5.47018 4.28854L1.87661 0.483918C1.70342 0.294943 1.45886 0.187346 1.20252 0.187346C0.946185 0.187346 0.70162 0.294943 0.528426 0.483918C0.349776 0.677609 0.251465 0.931988 0.253426 1.19548",
    fill: "currentColor"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_468_145"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 5.5,
    height: 10,
    fill: "currentColor",
    transform: "matrix(-1 0 0 -1 5.75 10)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronRight);
export default __webpack_public_path__ + "static/media/chevron-right.80dc373ec0a415afd789f2ea12d5c9d3.svg";
export { ForwardRef as ReactComponent };